import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const EditPageLoadingListener: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditPageLoadingListener" */ '../src/EditPageLoadingListener.tsx'
			)
		).EditPageLoadingListener,
});
